import React, { useState, useEffect } from 'react'
import { format } from 'date-fns'
import PropTypes from 'prop-types'
const CommunityEventList = (props) => {

    const section = props.section;
    const drmEndpoint = process.env.GATSBY_DRM_EVENTS_ENDPOINT

    // --- STATE ---
    const [requestData, setRequestData] = useState(true)
    const [loading, setLoading] = useState(true)
    const [allPastItems, setAllPastItems] = useState([])
    const [currentItems, setCurrentItems] = useState([])
    const [pastItems, setPastItems] = useState([])
    const [selectedEvent, setSelectedEvent] = useState([])
    // --- END OF STATE ---


    // --- EFFECTS ---
    useEffect(() => {
        if (requestData) {
            handleCardLoad()
        }
    }, [])

    /*
    useEffect(() => {
        console.log('useEffect selectedEvent')
        customElements.whenDefined("tm-card-grid-a").then(() => { 

            const intervalFix = setInterval(() => {
                const eventGrid = document.querySelector('#selected-event-grid');
                console.log('selected event type')
                console.log(typeof selectedEvent)
                if(eventGrid && typeof selectedEvent != 'undefined' ) {
                    let oneItem = document.createElement('tm-grid-item');
                    oneItem.setAttribute('title', selectedEvent.title);
                    oneItem.setAttribute('description', selectedEvent.description);
                    oneItem.setAttribute('img-src',selectedEvent.logo_url);
                    oneItem.setAttribute('cta-href',selectedEvent.website_url)
                    oneItem.setAttribute('cta-title','Visit the event site here')
                    oneItem.setAttribute('cta-target',true)
                    eventGrid.innerHTML = ''
                    eventGrid.appendChild(oneItem);
                    clearInterval(intervalFix)
                }
            }, 100)
        })
        
    },selectedEvent) 
    */

    const handleCardLoad = () => {
        setRequestData(false)
        fetch(drmEndpoint).then(res => res.json()).then(result => {
            let items = []

            result.map(item => {
                items.push(item)
            })

            const eventData = items
            let sortedData = eventData.sort((a, b) => new Date(a.start_date) - new Date(b.start_date))
            sortedData.forEach((element) => {
                const startDate = element?.start_date?.substring(0, 10);
                const endDate = element.end_date?.substring(0, 10);
                let monthsMap = new Map([
                    ["01", "January"],
                    ["02", "February"],
                    ["03", "March"],
                    ["04", "April"],
                    ["05", "May"],
                    ["06", "June"],
                    ["07", "July"],
                    ["08", "August"],
                    ["09", "September"],
                    ["10", "October"],
                    ["11", "November"],
                    ["12", "December"]

                ]);
                const sMonth = element?.start_date?.substring(5, 7); // to get  start month
                const eMonth = element?.end_date?.substring(5, 7); // to get  end month
                const startMonth = monthsMap.get(sMonth); // to get the start  month in words
                const endMonth = monthsMap.get(eMonth); // to get the end  month in words
                const sDate = element?.start_date?.substring(8, 10); //to get start date
                const eDate = element?.end_date?.substring(8, 10); //to get end date
                const sYear = element?.start_date?.substring(0, 4); //to get start year
                const eYear = element?.end_date?.substring(0, 4); //to get end year
                let date = "";
                if (sYear == eYear) {
                    if (startMonth == endMonth) {
                        if (sDate == eDate) {
                            //when both end date and start date is same
                            date = `${startMonth} ${sDate} ${sYear}`;
                        }
                        else {
                            //when startMonth and endMonth are same but startdate and enddate are diff
                            date = `${startMonth} ${sDate}-${eDate} ${sYear}`;
                        }
                    }
                    else {
                        //when year is same but startmonth and endMonth are diff
                        date = `${startMonth} ${sDate}-${endMonth} ${eDate} ${sYear}`;
                    }
                }
                else {
                    //when start year and end year are diff
                    date = `${startMonth} ${sDate} ${sYear}-${endMonth} ${eDate} ${eYear}`;
                }
                element.formattedDate = `${date}`

                // const start = format(new Date(startDate), 'MMMM d')
                // const end = element.start_date == element.end_date ? format(new Date(endDate), ' yyyy')
                //     : startMonth == endMonth ? format(new Date(endDate), '-d yyyy')
                //         : format(new Date(endDate), '-MMMM d yyyy')
                // element.formattedDate = `${start}${end}`

                element.city = element?.city == '.' ? '' : element.city
                element.country = element?.country == '.' ? '' : element.country
                element.state = element?.state == '.' ? '' : element.state
                element.location = `${element?.city ? element.city + ', ' : ''}${element?.state ? element.state + ', ' : ''}${element?.country ? element.country : ''}`
            })


            let cutOffDate = new Date()
            cutOffDate.setFullYear(cutOffDate.getFullYear() + 1)
            let calendarData = sortedData.filter((item) => { return ((new Date(item.end_date) >= new Date()) && (new Date(item.start_date) <= cutOffDate)) })
            let allPastData = sortedData.filter((item) => { return new Date(item.end_date) < new Date() }).reverse()

            let pastData = allPastData.slice(0, 10)

            setAllPastItems(allPastData)
            setCurrentItems(calendarData)
            setSelectedEvent(calendarData[0])
            setPastItems(pastData)
            handleRowClick(null, calendarData[0])
            setLoading(false)

        })
    }

    const handleRowClick = (event, item) => {
        console.log('handleRowClick')
        console.log(item.title)
        setSelectedEvent(item)
        customElements.whenDefined("tm-card-grid-a").then(() => {

            const intervalFix = setInterval(() => {
                const eventGrid = document.querySelector('#selected-event-grid');
                if (eventGrid && typeof selectedEvent != 'undefined') {
                    let oneItem = document.createElement('tm-grid-item');
                    oneItem.setAttribute('title', item.title);
                    oneItem.setAttribute('description', item.description);
                    oneItem.setAttribute('img-src', item.logo_url);
                    oneItem.setAttribute('cta-href', item.website_url)
                    oneItem.setAttribute('cta-title', 'Visit the event site here')
                    oneItem.setAttribute('cta-target', true)
                    eventGrid.innerHTML = ''
                    eventGrid.appendChild(oneItem);
                    clearInterval(intervalFix)
                }
            }, 100)
        })
    }

    return (
        <div>
            <div id="cards">
                {currentItems.length > 0 && loading && (
                    <center className="slds-p-top_xx-large H(550)">
                        <tds-spinner size="large"></tds-spinner>
                    </center>
                )}

                {(section === 'past' && pastItems.length > 0) && (
                    <div id="community-conferences-past-calendar">
                        <table>
                            <tbody>
                                {pastItems.map((item, index) => (
                                    <tr key={`past-calendar-row--${index}`} class="calendar-row" onClick={(e) => handleRowClick(e, item)} >
                                        <td><a target="_blank" href={item.website_url}>{item.title}</a></td>
                                        <td>{item.country}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                {(section === 'past-all' && pastItems.length > 0) && (
                    <div id="community-conferences-past-all-calendar" class="slds-container_medium slds-p-top_large slds-align_absolute-center">
                        <table>
                            <tbody>
                                {allPastItems.map((item, index) => (
                                    <tds-card class="slds-p-bottom_medium" key={`past-calendar-row--${index}`} content-mode="padded">
                                        <div class="slds-wrap slds-grid  slds-gutters">
                                            <div class="slds-col slds-wrap slds-grid  slds-gutters">
                                                <div class="slds-col past-event-logo slds-medium-size_2-of-8 slds-small-size_1-of-1 slds-m-right_small">
                                                    <img src={item.logo_url}></img>
                                                </div>
                                                <div class="slds-col">
                                                    <tds-button-link variant="base" href={item.website_url}>{item.title}</tds-button-link>
                                                    <p>{item.location}</p>

                                                </div>
                                            </div>
                                            <div class="slds-col slds-align-bottom">
                                                <div class="align-right">
                                                    {item.formattedDate}
                                                </div>
                                            </div>
                                        </div>
                                    </tds-card>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}

                {(section === 'calendar' && currentItems.length > 0) && (
                    <div class="slds-container_x-large slds-p-vertical_medium slds-grid  slds-wrap slds-gutters">
                        <div id="community-conferences-calendar" class="slds-col slds-medium-size_2-of-3 slds-small-size_1-of-1">
                            <table>
                                <thead>
                                    <th>Conference Name</th>
                                    <th>Location</th>
                                    <th>Date</th>
                                </thead>
                                <tbody>
                                    {currentItems.map((item, index) => (
                                        <tr key={`calendar-row--${index}`} class="calendar-row" onClick={(e) => handleRowClick(e, item)} >
                                            <td class="slds-m-vertical_small slds-p-right-x-small slds-p-bottom_small">
                                                <a target="_blank" href={item.website_url}>{item.title}</a>
                                            </td>
                                            <td class="slds-p-right_x-small">{item.location}</td>
                                            <td>{item.formattedDate}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div class="slds-col slds-medium-size_1-of-3 slds-small-size_1-of-1" >
                            <tm-card-grid-a class="slds-medium-size_1-of-1 slds-small-size_2-of-3" id="selected-event-grid" img-aspect="60%" img-type="full">
                            </tm-card-grid-a>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}


CommunityEventList.propTypes = {
    section: PropTypes.string
};
export default CommunityEventList
